import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const deviceTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default deviceTypeConfig;
